import { render } from "./RiRequest.vue?vue&type=template&id=7f6bb4d2"
import script from "./RiRequest.vue?vue&type=script&lang=js"
export * from "./RiRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiRequest.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f6bb4d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f6bb4d2', __exports__)) {
    api.reload('7f6bb4d2', __exports__)
  }
  
  module.hot.accept("./RiRequest.vue?vue&type=template&id=7f6bb4d2", () => {
    api.rerender('7f6bb4d2', render)
  })

}


export default __exports__